<div class="gd-panel">
  <section class="gd-card">
    <div class="gd-card__header">
      <span class="gd-card__title"><mat-icon>description</mat-icon> Información contable</span>
    </div>

    <app-loading-state *ngIf="loadingData" [compact]="true" message="Cargando…"></app-loading-state>

    <div class="gd-info" *ngIf="!loadingData">
      <div class="gd-info__row">
        <div class="gd-info__icon"><mat-icon>account_balance</mat-icon></div>
        <div class="gd-info__text">
          <span class="gd-info__label">Cuenta de ingreso</span>
          <span class="gd-info__value" [class.gd-info__value--muted]="!detail?.entranceAccount">{{ detail?.entranceAccount || 'Sin cuenta' }}</span>
        </div>
      </div>
      <div class="gd-info__row">
        <div class="gd-info__icon"><mat-icon>show_chart</mat-icon></div>
        <div class="gd-info__text">
          <span class="gd-info__label">Inversión vinculada</span>
          <span class="gd-info__value" [class.gd-info__value--muted]="!detail?.investmentName">{{ detail?.investmentName || 'Sin vincular' }}</span>
        </div>
      </div>
      <div class="gd-info__row">
        <div class="gd-info__icon"><mat-icon>attach_file</mat-icon></div>
        <div class="gd-info__text">
          <span class="gd-info__label">Documento</span>
          <span class="gd-info__value" [class.gd-info__value--muted]="!row.pdf && !row.image">{{ row.pdf ? 'PDF adjunto' : (row.image ? 'Imagen adjunta' : 'Sin documento') }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="gd-card">
    <div class="gd-card__header">
      <span class="gd-card__title"><mat-icon>assessment</mat-icon> Amortización</span>
      <button mat-stroked-button class="cf-btn" *ngIf="!loadingAmortisation && amortisation.length" (click)="exportAmortisation()">
        <mat-icon>file_download</mat-icon> Excel
      </button>
    </div>

    <app-loading-state *ngIf="loadingAmortisation" [compact]="true" message="Calculando amortización…"></app-loading-state>

    <ng-container *ngIf="!loadingAmortisation">
      <ng-container *ngIf="amortisation.length; else emptyAmortisation">
        <div class="gd-progress">
          <div class="gd-progress__bar">
            <div class="gd-progress__fill" [style.width.%]="amortisedPercent"></div>
          </div>
          <div class="gd-progress__legend">
            <span>Amortizado <strong>{{ summary.accumulated | number:'1.2-2' }} €</strong> ({{ amortisedPercent | number:'1.0-0' }} %)</span>
            <span>Pendiente <strong>{{ summary.remaining | number:'1.2-2' }} €</strong></span>
            <span>Total <strong>{{ summary.total | number:'1.2-2' }} €</strong></span>
          </div>
        </div>

        <div class="gd-table-wrap">
          <table class="gd-table">
            <thead>
              <tr>
                <th>Periodo</th>
                <th>Cuenta</th>
                <th class="gd-num">Importe</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of amortisation">
                <td>{{ r.month }} {{ r.year }}</td>
                <td>{{ r.accountActivity || '—' }}</td>
                <td class="gd-num">{{ r.amount | number:'1.2-2' }} €</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>

      <ng-template #emptyAmortisation>
        <div class="gd-empty">
          <mat-icon>info</mat-icon>
          <span *ngIf="amortisationError">No se pudo calcular la amortización.</span>
          <span *ngIf="!amortisationError">Sin amortización. Solo se calcula para subvenciones de capital vinculadas a una inversión.</span>
        </div>
      </ng-template>
    </ng-container>
  </section>
</div>
